/**
 * Is this debug? Using Next.js server-side search params in app router.
 */
export const getIsDebug = (searchParams: Record<string, string | string[]>) => {
  const rawIsDebug = Array.isArray(searchParams.isDebug)
    ? searchParams.isDebug[0]
    : searchParams.isDebug;

  return rawIsDebug === "true" || rawIsDebug === "1";
};
